import { render, staticRenderFns } from "./CreateWheel.vue?vue&type=template&id=52bcd38e&scoped=true"
import script from "./CreateWheel.vue?vue&type=script&lang=js"
export * from "./CreateWheel.vue?vue&type=script&lang=js"
import style0 from "./CreateWheel.vue?vue&type=style&index=0&id=52bcd38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bcd38e",
  null
  
)

export default component.exports